import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const reactionApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.apiAccessToken
      const tokenType = state.auth.tokenType
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "reactionApi",
  tagTypes: ["Reactions"],
  endpoints: (builder) => ({
    getPostReactions: builder.mutation<API.Response.GetReactionResponse, API.Payload.GetReactionPayload>({
      query: (payload) => ({
        url: "/recognition/reactions",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Reactions"],
    }),
    addPostReactions: builder.mutation<API.Response.AddReactionResponse, API.Payload.AddReactionPayload>({
      query: (payload) => ({
        url: "/recognition/reaction/add",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Reactions"],
    }),
    deletePostReactions: builder.mutation<API.Response.DeleteReactionResponse, API.Payload.DeleteReactionPayload>({
      query: (payload) => ({
        url: `/recognition/reaction/delete/${payload}`,
        method: "POST",
      }),
      invalidatesTags: ["Reactions"],
    }),
  }),
})

export const { useAddPostReactionsMutation, useGetPostReactionsMutation, useDeletePostReactionsMutation } = reactionApi
